import { http } from "."; // adjust the path if needed
import { SiteTypeConst } from "../constants";
import { AppConst } from "../constants";
//import { appConfig } from "../config";
 
export const getCpoDetails = (payload: { countryCd: string; productClassCd: string; siteTypeCd: string }) => {
  return http.get("/sitedetails/SiteDetail/GetCpo", {
    params: {
      CountryCd: payload.countryCd,
      ProductClassCd: payload.productClassCd,
      SiteTypeCd: payload.siteTypeCd,
    },
  });
};

export const shouldAutoAssignCPO = (productClassCd: string, siteType: string, country: string) => {
  return (
    (productClassCd === "30" &&
      siteType === SiteTypeConst.SHELL_IN_NETWORK_RETAIL_SITE &&
      AppConst.ALLOWED_CPO_COUNTRIES.includes(country)) ||
    (productClassCd === "30" &&
      siteType === SiteTypeConst.SHELL_LICENSED_MARKET_SITE &&
      country === "DK")
  );
};
